import { render, staticRenderFns } from "./ProjectGroupView.vue?vue&type=template&id=646a4f76&"
import script from "./ProjectGroupView.vue?vue&type=script&lang=js&"
export * from "./ProjectGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports